import React from "react";
import AuthGuard from "hoc/AuthGuard";
import { PracticeSession } from "design-system/template/practice/practice-session/practice-session";

const PracticeSessionPage = () => {
  return (
    <AuthGuard>
      <PracticeSession />
    </AuthGuard>
  );
};

export default PracticeSessionPage;
